import { mapGetters, mapActions } from "vuex";
import { types as VI } from "@/store/vi";

import { queryCoupon, getCoupon } from "@/libs/api.js";
const getters = mapGetters({
	getViStorage: VI.VI_STORAGE,
});
const actions = mapActions({
	setViStorage: VI.VI_STORAGE,
});

export default {
	name: "couponCenter",
	components: {},
	data() {
		return {
			coupons: [
				{
					amount: "5.0",
					batchId: "706405",
					batchIdCipher: "557849f1a80cce729625eded274ed048",
					categoryName: "电脑办公,精选",
					categoryType: "28,10001",
					couponBeginTime: "2020-06-04 00:00:00",
					couponEndTime: "2020-06-30 23:59:59",
					couponType: "1",
					couponUsedDesc: "邮乐商城PC端",
					couponWallFlag: "2",
					couponWallShowImgURL: "",
					expireBeginDate: "2020-06-12",
					expireDate: "领券后1天内有效",
					expireEndDate: "2020-06-13",
					filtercomdyGroupLimit: "",
					fullCutAmount: "2",
					issueCount: "9",
					limitGoodsidType: "2",
					listingId: "3635005,3635028",
					listingImgurl:
						"http://pic3.beta.ule.com/pic/user_800107977/product/prd20200521/bbd41e441f888b72_p450x450.jpg,http://pic0.beta.ule.com/item/user_800102953/desc20200602/2ebf8704bdbb479d_800x-1.jpg",
					listingName: "优惠劵不显示,测试卷",
					relativePageLink: "https://store.beta.ule.com/diystore/5388/index.html,https://store.beta.ule.com/diystore/2524/index.html",
					remark: "这是大网商品跨",
					singleIdCouponsLimit: "1",
					status: null,
					stock: "10",
					storeId: "5388,2524",
					storeImgUrl: "//static.beta.ulecdn.com/mstore/user_800107977/store_9999/images/20190725/e06c9450280fd9bd.png,CWNULL",
					storeName: "小苹果旗舰店,王者荣耀旗舰店",
					updateTimeLong: "1591268079000",
					userReceiveCountByBatchId: "0",
				},
				{
					amount: "1006.0",
					batchId: "706390",
					batchIdCipher: "e7e8a72235bd4a17ef0c8638d81c4555",
					categoryName: "家用电器,精选",
					categoryType: "11,10001",
					couponBeginTime: "2020-06-04 00:00:00",
					couponEndTime: "2020-06-30 23:59:59",
					couponType: "2",
					couponUsedDesc: "邮乐商城PC端",
					couponWallFlag: "1",
					couponWallShowImgURL: "",
					expireBeginDate: "2020-06-12",
					expireDate: "领券后1天内有效",
					expireEndDate: "2020-06-13",
					filtercomdyGroupLimit: "",
					fullCutAmount: "0",
					issueCount: "0",
					limitGoodsidType: "3",
					listingId: "",
					listingImgurl:
						"http://pic.beta.ule.com/pic/user_800101935/product/prd20191215/5745298764801ea6_p2160x1920.jpg,http://pic.beta.ule.com/pic/user_800101935/product/prd20191215/5745298764801ea6_p2160x1920.jpg,http://pic.beta.ule.com/pic/user_800101935/product/prd20191215/5745298764801ea6_p2160x1920.jpg",
					listingName: "商品名家用电器,精选",
					relativePageLink: "https://store.beta.ule.com/diystore/2492/index.html",
					remark: "品类卷大网",
					singleIdCouponsLimit: "100",
					status: null,
					stock: "100",
					storeId: "2492",
					storeImgUrl: "http://static.beta.ulecdn.com/mstore/user_800101935/store_9999/images/20171207/4545bbfd14ec3d6c.png",
					storeName: "辐射避难所旗舰店",
					updateTimeLong: "1591252544000",
					userReceiveCountByBatchId: "0",
				},
				{
					amount: "1005.0",
					batchId: "706389",
					batchIdCipher: "bf1f9da5f82253bc1f2b42eaf2d1bc2e",
					categoryName: "家用电器,精选",
					categoryType: "11,10001",
					couponBeginTime: "2020-06-04 00:00:00",
					couponEndTime: "2020-06-30 23:59:59",
					couponType: "3",
					couponUsedDesc: "邮乐商城PC端",
					couponWallFlag: "2",
					couponWallShowImgURL: "",
					expireBeginDate: "2020-06-12",
					expireDate: "领券后1天内有效",
					expireEndDate: "2020-06-13",
					filtercomdyGroupLimit: "",
					fullCutAmount: "0",
					issueCount: "1",
					limitGoodsidType: "3",
					listingId: "",
					listingImgurl: "",
					listingName: "",
					relativePageLink: "https://store.beta.ule.com/diystore/2492/index.html",
					remark: "品类卷大无库存",
					singleIdCouponsLimit: "1",
					status: null,
					stock: "1",
					storeId: "2492",
					storeImgUrl: "http://static.beta.ulecdn.com/mstore/user_800101935/store_9999/images/20171207/4545bbfd14ec3d6c.png",
					storeName: "辐射避难所旗舰店",
					updateTimeLong: "1591252519000",
					userReceiveCountByBatchId: "0",
				},
				{
					amount: "1005.0",
					batchId: "706389",
					batchIdCipher: "bf1f9da5f82253bc1f2b42eaf2d1bc2e",
					categoryName: "家用电器,精选",
					categoryType: "11,10001",
					couponBeginTime: "2020-06-04 00:00:00",
					couponEndTime: "2020-06-30 23:59:59",
					couponType: "4",
					couponUsedDesc: "邮乐商城PC端",
					couponWallFlag: "2",
					couponWallShowImgURL: "",
					expireBeginDate: "2020-06-12",
					expireDate: "领券后1天内有效",
					expireEndDate: "2020-06-13",
					filtercomdyGroupLimit: "",
					fullCutAmount: "0",
					issueCount: "1",
					limitGoodsidType: "3",
					listingId: "",
					listingImgurl: "",
					listingName: "",
					relativePageLink: "https://store.beta.ule.com/diystore/2492/index.html",
					remark: "品类卷大无库存",
					singleIdCouponsLimit: "1",
					status: null,
					stock: "1",
					storeId: "2492",
					storeImgUrl: "http://static.beta.ulecdn.com/mstore/user_800101935/store_9999/images/20171207/4545bbfd14ec3d6c.png",
					storeName: "辐射避难所旗舰店",
					updateTimeLong: "1591252519000",
					userReceiveCountByBatchId: "0",
				},
				{
					amount: "1005.0",
					batchId: "706389",
					batchIdCipher: "bf1f9da5f82253bc1f2b42eaf2d1bc2e",
					categoryName: "家用电器,精选",
					categoryType: "11,10001",
					couponBeginTime: "2020-06-04 00:00:00",
					couponEndTime: "2020-06-30 23:59:59",
					couponType: "5",
					couponUsedDesc: "邮乐商城PC端",
					couponWallFlag: "2",
					couponWallShowImgURL: "",
					expireBeginDate: "2020-06-12",
					expireDate: "领券后1天内有效",
					expireEndDate: "2020-06-13",
					filtercomdyGroupLimit: "",
					fullCutAmount: "0",
					issueCount: "1",
					limitGoodsidType: "3",
					listingId: "",
					listingImgurl: "",
					listingName: "",
					relativePageLink: "https://store.beta.ule.com/diystore/2492/index.html",
					remark: "品类卷大无库存",
					singleIdCouponsLimit: "1",
					status: null,
					stock: "1",
					storeId: "2492",
					storeImgUrl: "http://static.beta.ulecdn.com/mstore/user_800101935/store_9999/images/20171207/4545bbfd14ec3d6c.png",
					storeName: "辐射避难所旗舰店",
					updateTimeLong: "1591252519000",
					userReceiveCountByBatchId: "0",
				},
				{
					amount: "1005.0",
					batchId: "706389",
					batchIdCipher: "bf1f9da5f82253bc1f2b42eaf2d1bc2e",
					categoryName: "家用电器,精选",
					categoryType: "11,10001",
					couponBeginTime: "2020-06-04 00:00:00",
					couponEndTime: "2020-06-30 23:59:59",
					couponType: "6",
					couponUsedDesc: "邮乐商城PC端",
					couponWallFlag: "2",
					couponWallShowImgURL: "",
					expireBeginDate: "2020-06-12",
					expireDate: "领券后1天内有效",
					expireEndDate: "2020-06-13",
					filtercomdyGroupLimit: "",
					fullCutAmount: "0",
					issueCount: "1",
					limitGoodsidType: "3",
					listingId: "",
					listingImgurl: "",
					listingName: "",
					relativePageLink: "https://store.beta.ule.com/diystore/2492/index.html",
					remark: "品类卷大无库存",
					singleIdCouponsLimit: "1",
					status: null,
					stock: "1",
					storeId: "2492",
					storeImgUrl: "http://static.beta.ulecdn.com/mstore/user_800101935/store_9999/images/20171207/4545bbfd14ec3d6c.png",
					storeName: "辐射避难所旗舰店",
					updateTimeLong: "1591252519000",
					userReceiveCountByBatchId: "0",
				},
			],
			loading: false,
			finished: true,
		};
	},
	computed: {
		...getters,
		newCoupons() {
			this.coupons.map((item) => {
				//不同的券类型展示不同文字，颜色
				if (item.couponType == 1) {
					item.couponTypeText = "店铺券";
					item.couponTypeColor = "shop";
					item.couponName = item.storeName;
				} else if (item.couponType == 2) {
					item.couponTypeText = "商品券";
					item.couponTypeColor = "commodity";
					item.couponName = item.listingName;
				} else if (item.couponType == 3) {
					item.couponTypeText = "运费券";
					item.couponTypeColor = "freight";
					item.couponName = "运费券";
				} else if (item.couponType == 4) {
					item.couponTypeText = "充值券";
					item.couponTypeColor = "bill";
					item.couponName = "充值券";
				} else if (item.couponType == 5) {
					item.couponTypeText = "全场券";
					item.couponTypeColor = "popular";
					item.couponName = "全场券";
				} else if (item.couponType == 6) {
					item.couponTypeText = "品类券";
					item.couponTypeColor = "category";
					item.couponName = "品类券";
				}
			});
			return this.coupons;
		},
	},
	methods: {
		...actions,
		// 获取优惠券信息
		getCoupon(getCouponData, index) {
			// 已登录
			if (this.$cookies.get("mall_cookie") || this.$cookies.get("ul_utk")) {
				getCoupon(getCouponData, "jsonCallback").then((res) => {
					if (res.returnCode == "0000" || res.code == "0000") {
						this.$toast("领取成功");
						this.disabledCoupons.push(this.coupons[index]);
						this.coupons.splice(index, 1);
						// this.chosenCoupon = index;
					} else {
						this.$toast("领取优惠券失败");
					}
				});
			}
			// 未登录
			else {
				let targetUrl = `https://h5.${this.$uleUrl()}/yxd/community`;
				targetUrl = `${targetUrl}${this.$route.fullPath}`;
				console.log(this.$route.fullPath);
				console.log(targetUrl);
				this.$dialog
					.confirm({
						title: "提示",
						message: "请先登录",
					})
					.then(() => {
						if (this.$browser().miniprogram) {
							window.wx.miniProgram.navigateTo({
								url: "/pages/authorize?target=" + encodeURIComponent(targetUrl) + "&type=webView", //跳转非tabBar页面(目前就指非首页index)。参数以路径后面拼接即可
							});
						} else {
							window.location.href = `//m.${this.$uleUrl()}/muser/user/login?target=${encodeURIComponent(targetUrl)}`;
						}
					})
					.catch(() => {
						this.active = 0;
					});
			}
		},
		onLoad() {
			console.log("onLoad");
		},
		coupoPageBack() {
			this.$router.go(-1);
		},
	},
	created() {},
	mounted() {
		// 优鲜app
		if (this.$browser().ylxdsq) {
			// 小店去掉原生头
			window.dsBridge &&
				window.dsBridge.call("setNativeTitle", {
					title: "",
				});
		}
	},
};
